import React, { useState, useEffect } from 'react';
import {  Paper, Typography, Button, Grid } from '@material-ui/core'
import { useStyles } from './classes'
import Tags from '../../components/Tags/Tags';
import { Formik, Form} from "formik";
import Alert from '@material-ui/lab/Alert';
import * as api from '../../api/index.js';



const UserPreferences = () => {

  const classes = useStyles()
  const [initialValues, setInitialValues] = useState({

    tags: ["6044deb9b7e1b9b1d0825f24","6044df84b7e1b9b1d0825f25"]
    });
    
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFalse, setIsFalse] = useState(false);
  const [tags, setTags] = useState([]);
  const checkUpdates = JSON.parse(localStorage.getItem('userUpdate'));
  const fetchResults = async () => {
    try {

      const { data } = await api.getDetails();
      setInitialValues({ ...initialValues, tags: data.preferences })
      

    } catch (error) {
      console.log(error)
    }
  }
    useEffect(() => {
          fetchResults()
          if (checkUpdates) {
            localStorage.removeItem("userUpdate")
          }
          // eslint-disable-next-line
    }, [checkUpdates])
  
    useEffect(() => {
    loadData();

    /* eslint-disable */
  }, []);

  const loadData = async () => {
    try {
      const { data } = await api.getTags();
      setTags(data);

  
    } catch (error) {
      console.log(error)
    }
  };


  //  const tags = [{
  //   status: true,
  //   _id: "6044e084b7e1b9b1d0825f26",
  //   tagMaster: {
  //       status: true,
  //       _id: "603e14cd96bdf9719c7a48f9",
  //       name: "Meal Type",
  //       tagType: "all",
  //       __v: 0
  //   },
  //   name: "Lunch",
  //   __v: 0
  //  },
  //  ]
     
     const submit = async (e) => {

         try {
           
        
           const formData = { "preferences": e.tags }
           const { data } = await api.updateUser(formData);
            if (data) {
                setIsSuccess(true)
                setTimeout(() => {
                setIsSuccess(false)
                    }, 3000);   
                localStorage.setItem('userUpdate', JSON.stringify(formData));


              }
          } catch (error) {
               setIsFalse(true)
               setTimeout(() => {
                    setIsFalse(false)
                    }, 3000);  
          }
    };
  return (
    <>
             
        <Typography   className={classes.menuInfo} >
          User Preferences
        </Typography>
        
        <Paper className={classes.menus}>
         <div style={{display: "flex", flexDirection: "row", flexWrap:"wrap", justifyContent:"flex-start", alignContent:"flex-start", alignItems:"space-between", padding: 30,}}>
          <Grid container >
            <Grid item >
                     <Formik
              initialValues={initialValues}
              onSubmit={submit}
              enableReinitialize
        >
          {({
            isValid,
            dirty,
            resetForm,
            handleChange,
            handleBlur,
            values,
            setFieldValue,
          }) => {
            return (
              <Form>
                
                          <Tags
                          values={values}
                          setFieldValue={setFieldValue}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          tags={tags}
                        />
                       
                                        { isSuccess && (
                                          <>
                                            <Alert icon={false} onClose={() => {}} severity="success">
                                                Saved successfully!
                                            </Alert>
                                          </>
                                        )}
                                        
                                        { isFalse && (
                                          <>
                                            <Alert icon={false} onClose={() => {}} severity="error">
                                                Preferences add fail
                                            </Alert>
                                          </>
                                         )}
                                         

                
                                          <div style={{ display: "flex", justifyContent: "flex-end",  alignContent:"space-between", alignItems:"space-between", marginTop: 10,}}>
                                                        <Button variant="contained" className={classes.clear} onClick={resetForm}>
                                                          Clear
                                                        </Button> 
                                                      <Button
                                                            variant="contained"
                                                            className={classes.button}
                                                            disabled={!dirty || !isValid}
                                                            type="submit"
                                                            >
                                                            save
                                                        </Button>
                                           </div>

              </Form>
            );
          }}
        </Formik>

            </Grid>
          </Grid>
     
          
       
         </div>
        </Paper>
                
      
    </>
  )
}

export default UserPreferences